import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth, AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar/Navbar';
import Popular from './pages/Popular/Popular';
import ShowDetails from './pages/ShowDetails/ShowDetails';
import Search from './pages/Search/Search';
import Watchlist from './pages/Watchlist/Watchlist';
import Friends from './pages/Friends/Friends';
import Tips from './pages/Tips/TipsPage';
import FriendProfile from './pages/FriendProfile/FriendProfile';
import { WatchlistProvider } from './context/WatchlistContext';
import { db } from './config/firebase';
import { doc, getDoc } from 'firebase/firestore';
import LoginPrompt from './components/LoginPrompt/LoginPrompt';
import { Spinner } from './components/Spinner/Spinner';
import Maintenance from './pages/Maintenance/Maintenance';
import TipsPage from './pages/Tips/TipsPage';
import PreTipsPage from './pages/Tips/PreTipsPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import Activity from './pages/Activity/Activity';

// Make Firebase instances available globally
window.db = db;
window.firestore = { doc, getDoc };

// Move ProtectedRoute inside the AuthProvider context
function AppRoutes() {
  const { user, loading } = useAuth();

  return (
    <WatchlistProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="app">
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Navigate to="/popular" replace />} />
              <Route path="/login" element={
                user ? <Navigate to="/popular" replace /> : <LoginPrompt />
              } />
              
              {/* Public Routes */}
              <Route path="/show/:id" element={<ShowDetails />} />
              <Route path="/maintenance" element={<Maintenance />} />

              {/* Protected Routes */}
              <Route path="/popular" element={
                <ProtectedRoute>
                  <Popular />
                </ProtectedRoute>
              } />
              <Route path="/search" element={
                <ProtectedRoute>
                  <Search />
                </ProtectedRoute>
              } />
              <Route path="/watchlist" element={
                <ProtectedRoute>
                  <Watchlist />
                </ProtectedRoute>
              } />
              <Route path="/friends" element={
                <ProtectedRoute>
                  <Friends />
                </ProtectedRoute>
              } />
              <Route path="/friend/:userId" element={
                <ProtectedRoute>
                  <FriendProfile />
                </ProtectedRoute>
              } />
              <Route path="/tips" element={
                <ProtectedRoute>
                  <TipsPage />
                </ProtectedRoute>
              } />
              <Route path="/tips/pre" element={
                <ProtectedRoute>
                  <PreTipsPage />
                </ProtectedRoute>
              } />
              <Route path="/profile/:userId" element={
                <ProtectedRoute>
                  <FriendProfile />
                </ProtectedRoute>
              } />
              <Route path="/activity" element={
                <ProtectedRoute>
                  <Activity />
                </ProtectedRoute>
              } />
              
              <Route path="*" element={<Navigate to="/popular" replace />} />
            </Routes>
          </main>
          <Navbar />
        </div>
      </Router>
    </WatchlistProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App; 